import axiosInstance from "./axiosInstance";

const getThirtyDaysLeaderboard = async () => {
  const accessToken = localStorage.getItem("accessTokenGC");
  try {
    const {data} = await axiosInstance.get(`/api/getThirtyDaysLeaderboard`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return data;
  } catch (error) {
    throw new Error("Error fetching user points.");
  }
};

export default getThirtyDaysLeaderboard;
